.avatar {
  position: relative;
  flex: none;
  box-sizing: border-box;
  display: inline-grid;
  place-items: center;
  border-radius: 50%;
  overflow: hidden;
  font-family: var(--font-display);
  color: var(--text);
  background: var(--card-tint, var(--pill-bg, transparent));
  border: 1px solid var(--line);
}

.ring {
  border: 2px solid var(--accent);
}

.photo {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.initial {
  line-height: 1;
}
